import React, { useState } from "react";
import styled from "styled-components";
// import { ResizableBox } from "react-resizable";
import PropTypes from "prop-types";
import Draggable from "react-draggable";
import CapLabel from "../CapLabel";
import CapColumn from "../CapColumn";
import CapIcon from "../CapIcon";
import CapLink from "../CapLink";
import CapHeading from "../CapHeading";
import CapRow from "../CapRow";
// import "react-resizable/css/styles.css";
import "./_capSupportVideosWrapper.scss";
import {
  closeIconLeftPositionMaximised,
  closeIconLeftPositionMinimised,
  closeIconTopPositionMaximised,
  closeIconTopPositionMinimised,
  draggableDivLeftMaximised,
  draggableDivLeftMinimised,
  draggableDivTopMaximised,
  draggableDivTopMinimised,
  expanderIconTopMaximised,
  expanderIconTopMinimised,
  maximisedHeight,
  maximisedWidth,
  CAP_SUPPORT_VIDEO_TITLE,
} from "./constants";
import { CAP_G07, CAP_WHITE } from "../styled/variables";

const classPrefix = "cap-resizable-pip";

const DraggableDiv = styled.div`
  z-index: 1000;
  position: absolute;
  left: ${props =>
    props.showMaximised
      ? draggableDivLeftMaximised
      : draggableDivLeftMinimised};
  top: ${props =>
    props.showMaximised ? draggableDivTopMaximised : draggableDivTopMinimised};
  box-sizing: content-box;
  box-shadow: 1px 3px 3px 0 rgb(0 0 0 / 20%), 1px 3px 15px 2px rgb(0 0 0 / 20%);
  border-radius: 4px;
  background-color: #fff;
`;

const HoverChildrenDiv = styled.div`
  height: ${props => props.pipHeight}px;
  width: ${props => props.pipWidth}px;
  color: #000;
  background-color: rgba(0, 0, 0, 0.3);
  transition: "opacity 0.5s ease-in-out";
`;

const ResizablePIP = ({
  children,
  width = 400,
  height = 250,
  showMaximised = false,
  handleShowMaximised,
  // minConstraints = [400, 310],
  // maxConstraints = [1104, 722],
  closePIPContainer = () => {},
  footerContent = {}
}) => {
  const [pipWidth, setPipWidth] = useState(width);
  const [pipHeight, setPipHeight] = useState(height);
  const [isHovering, setIsHovering] = useState(false);
  const handleMouseEnter = () => setIsHovering(true);
  const handleMouseLeave = () => setIsHovering(false);
  const handleMaximiseView = () => {
    if (!showMaximised) {
      setPipWidth(maximisedWidth);
      setPipHeight(maximisedHeight);
    } else {
      setPipWidth(width);
      setPipHeight(height);
    }
    handleShowMaximised(!showMaximised);
  };

  const handleOpenDoc = () => window.open(footerContent.supportDoc, "_blank");
  const videoTitleClassName = showMaximised ? `${CAP_SUPPORT_VIDEO_TITLE}-maximized` : CAP_SUPPORT_VIDEO_TITLE;

  return (
    <div className={classPrefix}>
      <Draggable handle="button">
        <DraggableDiv showMaximised={showMaximised}>
          {(isHovering || showMaximised) && (
            <CapIcon
              className="cap-support-video-close-icon"
              onClick={closePIPContainer}
              size="m"
              type="close"
              style={{
                top: showMaximised
                  ? closeIconTopPositionMaximised
                  : closeIconTopPositionMinimised,
                left: showMaximised
                  ? closeIconLeftPositionMaximised
                  : closeIconLeftPositionMinimised,
                backgroundColor: showMaximised ? CAP_G07 : "unset",
                color: !showMaximised ? CAP_WHITE : 'unset',
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
          )}
          {/* <ResizableBox
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            width={pipWidth}
            height={pipHeight}
            minConstraints={minConstraints}
            maxConstraints={maxConstraints}
          > */}
          <HoverChildrenDiv
            pipHeight={pipHeight}
            pipWidth={pipWidth}
            isHovering={isHovering}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {children}
          </HoverChildrenDiv>
          <CapRow className="cap-support-video-footer">
            <CapColumn span={17}>
              <CapHeading type="h3" className={videoTitleClassName} title={footerContent.videoTitle}>
                {footerContent.videoTitle}
              </CapHeading>
            </CapColumn>
            <CapLink
              className="cap-support-video-doc-link"
              onClick={handleOpenDoc}
              title={
                <CapHeading className="cap-support-video-doc-link-title" type="h5">
                  <CapLabel type="label15">View docs</CapLabel>
                  <CapIcon
                    onClick={handleOpenDoc}
                    size="s"
                    type="open-in-new"
                  />
                </CapHeading>
              }
            />
          </CapRow>
          {/* </ResizableBox> */}
          {isHovering && (
            <div
              className="cap-support-video-pos-fixed"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <CapIcon
                onClick={handleMaximiseView}
                size="s"
                aria-label="expander-and-minimizer-icon"
                type={showMaximised ? "minimizer" : "expander"}
                className="cap-support-video-maximize"
                style={{
                  top: showMaximised
                    ? expanderIconTopMaximised
                    : expanderIconTopMinimised
                }}
                svgProps={{ fill: CAP_WHITE, }}
              />
              {!showMaximised && (
                <button type="button" className="cap-support-video-cursor-pointer">
                  <CapIcon
                    size="s"
                    type="draggable"
                    className="cap-support-video-dragger"
                    style={{
                      top: showMaximised
                        ? expanderIconTopMaximised
                        : expanderIconTopMinimised
                    }}
                    svgProps={{ fill: CAP_WHITE, }}
                  />
                </button>
              )}
            </div>
          )}
        </DraggableDiv>
      </Draggable>
    </div>
  );
};

ResizablePIP.propTypes = {
  children: PropTypes.any,
  width: PropTypes.number,
  height: PropTypes.number,
  // minConstraints: PropTypes.array,
  // maxConstraints: PropTypes.array,
  closePIPContainer: PropTypes.func,
  handleShowMaximised: PropTypes.func,
  showMaximised: PropTypes.bool,
  footerContent: PropTypes.object
};
export default ResizablePIP;
